import { render, staticRenderFns } from "./ActivityHiddenImageWithTextContainer.vue?vue&type=template&id=1609f84c"
import script from "./ActivityHiddenImageWithTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityHiddenImageWithTextContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports